import { FC } from 'react';

import StepHeader from '@components/quiz/shared/StepHeader';
import type { SanityQuizTopBanner } from '@lib/sanity/types';

type TopBannerProps = {
  banner?: SanityQuizTopBanner;
};

/**
 * The per-step header at the top of every readiness step: the shared,
 * GYTR-style centred header (accent eyebrow, bold heading, subtext), all
 * editable in Sanity.
 */
const TopBanner: FC<TopBannerProps> = ({ banner }) => {
  if (!banner?.heading) return null;

  return (
    <div className="bg-neutral-100 px-6 pb-2 pt-6">
      <StepHeader
        eyebrow={banner.eyebrow}
        heading={banner.heading}
        subtext={banner.subtext}
        className="mx-auto max-w-sm"
      />
    </div>
  );
};

export default TopBanner;
